import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
	TEmVatStore,
	TEmVatListRequest,
	TEmVatListResponse,
	TEmVatCreateRequest,
	TEmVatUpdateRequest,
	TEmVatDeleteRequest,
} from './types';

export const initialState: TEmVatStore = {
	emVatList: null,
	emVatListLoading: false,
	createEmVatLoading: false,
	createEmVatSuccess: false,
	updateEmVatLoading: false,
	updateEmVatSuccess: false,
	deleteEmVatLoading: false,
	deleteEmVatSuccess: false,
};

const emVat = createSlice({
	name: '@@emVat',
	initialState,
	reducers: {
		getEmVatListRequest: (state: TEmVatStore, _action: PayloadAction<TEmVatListRequest>) => {
			const emVatState = state;
			emVatState.emVatListLoading = true;
		},
		getEmVatListSuccess: (state: TEmVatStore, action: PayloadAction<TEmVatListResponse>) => {
			const { payload } = action;
			const emVatState = state;
			emVatState.emVatList = payload;
			emVatState.emVatListLoading = false;
		},

		createEmVatRequest: (state: TEmVatStore, _action: PayloadAction<TEmVatCreateRequest>) => {
			const emVatState = state;
			emVatState.createEmVatLoading = true;
			emVatState.createEmVatSuccess = false;
		},
		createEmVatSuccess: (state: TEmVatStore) => {
			const emVatState = state;
			emVatState.createEmVatLoading = false;
			emVatState.createEmVatSuccess = true;
		},

		updateEmVatRequest: (state: TEmVatStore, _action: PayloadAction<TEmVatUpdateRequest>) => {
			const emVatState = state;
			emVatState.updateEmVatLoading = true;
			emVatState.updateEmVatSuccess = false;
		},
		updateEmVatSuccess: (state: TEmVatStore) => {
			const emVatState = state;
			emVatState.updateEmVatLoading = false;
			emVatState.updateEmVatSuccess = true;
		},

		deleteEmVatRequest: (state: TEmVatStore, _action: PayloadAction<TEmVatDeleteRequest>) => {
			const emVatState = state;
			emVatState.deleteEmVatLoading = true;
			emVatState.deleteEmVatSuccess = false;
		},
		deleteEmVatSuccess: (state: TEmVatStore) => {
			const emVatState = state;
			emVatState.deleteEmVatLoading = false;
			emVatState.deleteEmVatSuccess = true;
		},

		assetsInitState: () => initialState,
	},
});

export default emVat.reducer;
export const {
	getEmVatListRequest,
	getEmVatListSuccess,
	createEmVatRequest,
	createEmVatSuccess,
	updateEmVatRequest,
	updateEmVatSuccess,
	deleteEmVatRequest,
	deleteEmVatSuccess,
	assetsInitState,
} = emVat.actions;
